import { useQuery } from "react-query";

import { useSingleConnector } from "../useConnectors";
import { getConnectorData, getConnectorEnergyConsumptionData } from "../../services/stationsAPI";
import { useGetAnalysisFilter } from "../../../../common/analysis/filter/hook/core/useFilterAnalysisCore";
import { MeasurandData } from "../../types/stations.types";

export const useConnectorEnergyConsumptionData = () => {

    
    const {filter} = useGetAnalysisFilter();
    

    const {connectorIdFound} = useSingleConnector({});


    const energyConsumptionConnector = useQuery({
        queryKey: ['connectorEnergyConsumption', connectorIdFound, filter],
        queryFn: () => getConnectorEnergyConsumptionData(connectorIdFound || "none", filter),
        enabled: !!connectorIdFound,
        refetchOnWindowFocus: false,
    })  



    return {
        filter,
        energyConsumptionConnector,
    }
}


export const useConnectorData = (measurand: MeasurandData, connectorId?: string) => {

    
    const {filter} = useGetAnalysisFilter();
    

    const {connectorIdFound} = useSingleConnector({connectorId});



    const queryData = useQuery({
        queryKey: ['connector-data',measurand ,connectorIdFound, filter],
        queryFn: () => getConnectorData(connectorIdFound || "none",measurand, filter),
        enabled: !!connectorIdFound,
        refetchOnWindowFocus: false,
    })  



    return {
        filter,
        queryData,
    }
}